import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import {ViewportScroller} from '@angular/common';

interface BookingAppointmentInfo {
  title: string;
  description: string;
  routerLink: string;
}

@Component({
    selector: 'app-bookings',
    templateUrl: './bookings.component.html',
    styleUrls: ['./bookings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingsComponent implements OnInit {

  appointmentInfos: BookingAppointmentInfo[] = [

    {
      title: 'Ownership Services',
      description: 'ContactAssessor.OwnerShip2',
      routerLink: 'LACAssessorOwnershipServices'
    },
    {
      title: 'Contact Your District',
      description: 'ContactAssessor.Districtdesc',
      routerLink: 'district'
    },
    {
      title: 'Homeowners\' Exemption',
      description: 'ContactAssessor.HomeExemptions',
      routerLink: 'LACAssessorHomeownersExemption'
    },
    {
      title: 'Disabled Veterans',
      description: 'ContactAssessor.DisableVets',
      routerLink: 'LACAssessorDisabledVeterans'
    },
    {
      title: 'Major Exemptions',
      description: 'ContactAssessor.MajorExemptionsv2',
      routerLink: 'LACAssessorMajorExemptions'
    },
    {
      title: 'Public Service',
      description: 'ContactAssessor.PublicService',
      routerLink: 'LACAssessorPublicServices'
    },
    // {
    //   title: 'Major Personal Properties',
    //   description: 'All tangible property owned or leased that is used for a business, except real property.',
    //   routerLink: 'LACAssessorBusinessPersonalProperty'
    // },
    {
      title: 'Mapping Services',
      description: 'ContactAssessor.Mapping',
      routerLink: 'LACAssessorGISMapping'
    },
    {
      title: 'Data Sales',
      description: 'ContactAssessor.DataSales',
      routerLink: 'LACAssessorDataSales'
    },
    {
      title: 'Public Information Officer',
      description: 'ContactAssessor.PublicInformation',
      routerLink: 'LACAssessorPublicInformationOfficer'
    },
    {
      title: 'Major Real Properties',
      description: 'ContactAssessor.MajorProperties',
      routerLink: 'LACAssessorMajorRealProperty'
    },
    {
      title: 'Marine, Aircraft, Mobile Homes',
      description: 'ContactAssessor.Marineair',
      routerLink: 'LACAssessorMarineAircraft'
    },
    {
      title: 'Special Properties, Apartments, Vending and Leasing',
      description: 'ContactAssessor.SpecialProperties',
      routerLink: 'LACAssessorMajorPersonalProperty'
    },
    // {
    //   title: 'Manufactured Homes',
    //   description: 'ContactAssessor.ManufacturedHomes',
    //   routerLink: 'LACAssessorManufacturedHomes'
    // },
    // {
    //   title: 'Marine/ Aircraft/ Airlines',
    //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    //   routerLink: 'LACAssessorPublicServices'
    // },
    // {
    //   title: 'Special Investigations',
    //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    //   routerLink: 'LACAssessorSpecialInvestigations'
    // },
    // {
    //   title: 'Subpoenas/ Records',
    //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    //   routerLink: 'LACAssessorPublicServices'
    // }
  ];

  constructor(public router: Router,
              private viewportScroller: ViewportScroller) { }

  ngOnInit(): void {
  }

  routeToLink(form: string): void {
    this.smoothScrollToTop();

    if (!form.startsWith('LAC')) {
      this.router.navigateByUrl('/contact/' + form);
      return;
    }

    this.router.navigateByUrl('/contact/appointment/' + form);
  }

  smoothScrollToTop(): void {
    this.viewportScroller.scrollToAnchor('alert-bar');
  }
}
